/*
 * Copyright (c) 2023-2025. Haodong JU
 */

import { FireBaseAuth, FireBaseStore } from '@/model/firebase/google-fire-base'
import { collection, deleteDoc, doc, getDoc, serverTimestamp } from 'firebase/firestore'
import IKUtils from 'innerken-js-utils'
import i18n from '@/i18n'
import { getCurrentUserId } from '@/model/dataLayer/api/SaaS/user'
import { Remember } from '@/model/global/GlobalSettings'
import hillo from 'hillo'

export function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const cloudV2Url = 'https://cloud-v2.aaden.io/'
// export const cloudV2Url = 'https://9957-2a02-8108-9491-4900-f40a-3f0-af9e-d69c.ngrok-free.app/'

export async function createPaymentUrlForProductList (
  productList,
  currentStoreId = null,
  trialDate = 0
) {
  const list = productList.map(it => {
    return {
      quantity: it?.count ?? 1,
      priceId: it.realPrice.id
    }
  })
  let mode = 'payment'
  if (productList.find(it => it.prices[0].type !== 'one_time')) {
    mode = 'subscription'
  }
  const baseUrl = location.origin
  const params = {
    cancelUrl: baseUrl + '/',
    successUrl: baseUrl + '/',
    mode,
    lineItems: list,
    email: FireBaseAuth.currentUser.email,
    cloudUserId: getCurrentUserId(),
    metadata: {
      storeId: currentStoreId,
      userId: getCurrentUserId(),
      productCodes: productList.map(it => it.metadata.code).join(',')
    }
  }
  if (trialDate > 0) {
    params.trialPeriodDays =
      trialDate
  }
  return (await hillo.jsonPost(cloudV2Url + 'subscriptions/create', params, {}))
}

export async function doPayment (
  productList,
  currentStoreId = null,
  trialDate = 0
) {
  const session = await createPaymentUrlForProductList(productList, currentStoreId, trialDate)
  Remember.shouldWait5Seconds = true
  await sleep(50)
  window.location.href = session
}

const path = 'trialCode'

export async function checkTrialCode (productCodes = []) {
  const ref = collection(FireBaseStore, path)
  const trialCode = await IKUtils.showInput(i18n.t('PleaseInputTrialCode'), 'text')
  if (trialCode === 'test') {
    return 90
  }
  if (trialCode === 'monthTrial') {
    return 30
  }
  const data = await getDoc(doc(ref, trialCode))
  const info = data.data()
  if (productCodes.includes(info.productCode)) {
    if (info.oneTime) {
      await deleteDoc(doc(ref, trialCode))
    }
    return info.trialDate
  } else {
    return null
  }
}

export function currentTimestampFirebase () {
  return serverTimestamp()
}
